// extracted by mini-css-extract-plugin
export default {"nombre":"TablaClubEstadios_nombre__CJkBN","desde":"TablaClubEstadios_desde__X19hS","hasta":"TablaClubEstadios_hasta__4IWME"};